import { render, staticRenderFns } from "./ConfigsFormClosed.vue?vue&type=template&id=3c4a7040&scoped=true&"
import script from "./ConfigsFormClosed.vue?vue&type=script&lang=js&"
export * from "./ConfigsFormClosed.vue?vue&type=script&lang=js&"
import style0 from "./ConfigsFormClosed.vue?vue&type=style&index=0&id=3c4a7040&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a7040",
  null
  
)

export default component.exports